import React, { FC } from 'react';

import { ContentModule } from '@nhl/nhl-react-ui/lib/ContentModule';

import TemplateKeys from '../../../utils/contentModuleTemplateKeys';
import ContentModulesBySeason from '../contentModulesBySeason';

import './styles.scss';

type Props = {
    templateKey?: string;
    templateKeyDescription?: string;
    header?: string;
    headerContent?: any;
    note?: string;
    subNav?: any;
    className?: string;
    children?: any;
    contentModulesBySeason?: number;
};

const TableLayout: FC<Props> = ({
    templateKey = undefined,
    templateKeyDescription = undefined,
    header = undefined,
    headerContent = null,
    note = undefined,
    subNav = null,
    className = '',
    children,
    contentModulesBySeason,
}: Props) => {
    const tableClassName = `table-layout-container ${className}`;
    return (
        <div className={tableClassName}>
            {templateKey && !contentModulesBySeason && (
                <ContentModule
                    className="hero-module"
                    baseUrl={window.recordsSettings.franchiseScopedRestUrl}
                    templateKey={TemplateKeys[templateKey] || templateKey}
                    sequence={1}
                    isPublic
                />
            )}
            {templateKey && contentModulesBySeason && (
                <ContentModulesBySeason
                    className="hero-module"
                    templateKey={TemplateKeys[templateKey] || templateKey}
                    seasonId={contentModulesBySeason}
                    sequence={1}
                />
            )}

            {subNav}

            <div className="table-layout-content">
                {header && (
                    <div className="table-layout-content-header">
                        <h2>{header}</h2>
                        {note && (
                            <div>
                                <i>{note}</i>
                            </div>
                        )}
                    </div>
                )}
                {headerContent && headerContent}
                {templateKeyDescription && (
                    <ContentModule
                        className="description-module"
                        baseUrl={window.recordsSettings.franchiseScopedRestUrl}
                        templateKey={TemplateKeys[templateKeyDescription]}
                        sequence={2}
                        isPublic
                    />
                )}
                <div className="table-layout-table-wrapper">{children}</div>
            </div>
        </div>
    );
};

export default TableLayout;
